<template>
  <div class="drainagePipeBody">
    <div style="display: flex; flex-direction: column; height: fit-content">
      <div style="display: flex; flex-direction: column">
        <el-form label-width="auto">
          <div style="display: flex; flex-direction: row">
            <el-form-item label="所属区域：">
              <el-select
                v-model="dictValueItem"
                value-key="dictValue"
                placeholder="请选择所属区域"
                @change="regionNameChange"
                style="width: 250px; margin-right: 10px"
              >
                <el-option
                  v-for="item in this.regionNameList"
                  :key="item.dictValue"
                  :label="item.dictName"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <div>
              <el-form-item label="道路(小区)：">
                <el-select
                  v-model="roadListItem"
                  value-key="id"
                  allow-create
                  filterable
                  placeholder="请选择道路(小区)"
                  style="width: 250px; margin-right: 10px"
                >
                  <el-option
                    v-for="item in this.roadList"
                    :key="item.id"
                    :label="item.roadName"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>

            <div>
              <el-form-item label="管井类型：">
                <el-select
                  v-model="queryForm.source"
                  placeholder="请选择管井类型"
                  style="width: 200px; margin-right: 10px"
                >
                  <el-option label="全部" value="" />
                  <el-option label="雨水井" value="1" />
                  <el-option label="污水井" value="2" />
                </el-select>
              </el-form-item>
            </div>
          </div>

          <div
            style="
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              margin-top: 10px;
            "
          >
            <div
              style="display: flex; flex-direction: row; align-items: center"
            >
              井盖类型：
              <div
                style="display: flex; flex-direction: row; align-items: center"
              >
                <el-radio v-model="queryForm.wellLidType" label=""
                  >全部</el-radio
                >
                <el-radio v-model="queryForm.wellLidType" label="1"
                  >普通井盖</el-radio
                >
                <el-radio v-model="queryForm.wellLidType" label="2"
                  >智能井盖</el-radio
                >
              </div>
            </div>

            <div>
              <el-button
                type="primary"
                style="margin-right: 10px"
                @click="submitSearch()"
                >查询</el-button
              >
              <el-button
                type="medium"
                style="margin-right: 15px"
                @click="resetOption()"
                >重置</el-button
              >
              <el-button
                type="primary"
                style="margin-right: 10px"
                @click="openUploadDialog()"
                >上传</el-button
              >
              <el-button
                type="primary"
                style="margin-right: 10px"
                @click="downloadExcel()"
                >导出</el-button
              >
              <el-button
                type="primary"
                style="margin-right: 10px"
                @click="downloadTemplateExcel()"
                >模板下载</el-button
              >
            </div>
          </div>

          <el-divider />
        </el-form>
      </div>

      <div class="tableContainer">
        <el-table
          v-loading="listLoading"
          :data="dataList"
          border
          fit
          highlight-current-row
        >
          <el-table-column label="ID" prop="id" align="center" width="100" />
          <el-table-column
            label="管井标号"
            prop="gdid"
            width="100"
            align="center"
          />
          <el-table-column
            label="所属区域"
            prop="townName"
            width="150"
            align="center"
          />
          <el-table-column
            label="道路(小区)"
            prop="roadName"
            width="180"
            align="center"
          />
          <el-table-column
            label="管井类型"
            prop="source"
            width="150"
            align="center"
            :formatter="sourceFormat"
          />
          <el-table-column
            label="横坐标"
            prop="xcoordinate"
            width="150"
            align="center"
          />
          <el-table-column
            label="纵坐标"
            prop="ycoordinate"
            width="150"
            align="center"
          />
          <el-table-column label="本号点" prop=thisPointNumber" width="150"
          align="center" />
          <el-table-column
            label="井盖材质"
            prop="manholeCoverMaterial"
            width="150"
            align="center"
          />
          <el-table-column
            label="井盖形状"
            prop="shape"
            width="150"
            align="center"
          />
          <el-table-column
            label="井盖直径"
            prop="wellZj"
            width="150"
            align="center"
          />
          <el-table-column
            label="井盖尺寸"
            prop="manholeCoverSize"
            width="150"
            align="center"
          />
          <el-table-column
            label="井脖深"
            prop="neckDepth"
            width="150"
            align="center"
          />
          <el-table-column
            label="防坠形式"
            prop="fallPreventionForm"
            width="150"
            align="center"
          />
          <el-table-column
            label="埋深"
            prop="burialDepth"
            width="150"
            align="center"
          />
          <el-table-column
            label="探测日期"
            prop="tcrq"
            width="150"
            align="center"
          />
          <el-table-column
            label="井盖类型"
            prop="wellLidType"
            width="150"
            align="center"
          />

          <el-table-column
            label="二维码"
            prop="qrcodeUrl"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              <el-popover
                v-show="scope.row.qrcodeUrl != null"
                placement="top"
                trigger="click"
              >
                <img
                  :src="scope.row.qrcodeUrl"
                  style="width: 200px; height: 200px"
                  alt=""
                />

                <el-button slot="reference">查看</el-button>
              </el-popover>
            </template>
          </el-table-column>

          <el-table-column
            label="录入时间"
            prop="createTime"
            width="200"
            align="center"
          />

          <el-table-column
            label="录入途径"
            prop="inputChannel"
            width="200"
            align="center"
          />
          <el-table-column
            label="易堵易冒"
            prop="blockBurst"
            width="200"
            align="center"
          />
          <el-table-column
            label="操作"
            prop="inputChannel"
            width="200"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="blockOrBurst(scope.row)"
                >设置易堵易冒
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <!--页码-->
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="queryForm.current"
          :limit.sync="queryForm.size"
          @pagination="getWellByPageDto"
        />
      </div>
    </div>

    <el-dialog title="上传" :visible.sync="uploadDialogVisibleFlag" width="30%">
      <el-upload
        class="file-uploader"
        action="#"
        accept=".xlsx,.xls"
        :http-request="handlexlslFile"
        :show-file-list="false"
        :before-upload="beforeFileUpload"
      >
        <el-button size="medium" type="text">上传文件</el-button>
      </el-upload>

      {{ filename }}

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitUploadFile()">上 传</el-button>
        <el-button @click="uploadDialogVisibleFlag = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style scoped lang="scss">
.drainagePipeBody {
  width: auto;
  height: 100%;
  padding: 24px;
  overflow: hidden;
  overflow-y: auto;
}
</style>

<script>
import Pagination from '@/components/PaginationStyle1.vue';
import {
  blockOrBurst,
  createPipeSegments,
  exportExcelwell,
  getWellByPageDto,
  uploadExcelWell,
} from '@/api/pipenetmanagement';
import { getCurrentFormattedDateTime } from '@/utils/TimeUtils';
import { getDictList } from '@/api/equipmentmanagement';
import CommonApi from '@/api/common';
import CommonFile from '@/api/common';
import CommonUtil from '@/utils/commonUtil';

export default {
  name: 'Well',
  components: { Pagination },
  data() {
    return {
      listLoading: false,
      dataList: [],
      total: 0,
      // fallPreventionTxt: "",
      queryForm: {
        current: 1,
        size: 10,
        townCode: '',
        roadId: '',
        source: '',

        // caliber: "",
        // category: "",
        // fallPrevention: "",          //有         无   不选
        // fallPreventionForm: "",      //防坠网
        // manholeCoverMaterial: "",
        // manholeCoverSize: "",
        // roadName: "",
        // type: "",
        // wellFrameMaterial: "",
        // wellFrameSize: "",
        // wellLidType: "",
        // regionName: "",
      },

      dictValueItem: {},
      roadList: [],
      roadListItem: {},

      queryRoadName: '',
      queryRoadId: 0,

      uploadDialogVisibleFlag: false,
      filename: '',
      uploadFile: null,

      regionNameList: [],
    };
  },
  methods: {
    async getDictList() {
      const result = await getDictList({ dictCode: 'town_code' });
      // console.log(result.data.data)
      this.regionNameList = result.data.data;
    },
    async getWellByPageDto() {
      this.listLoading = true;
      const result = await getWellByPageDto(this.queryForm);
      const list = result.data.data.records;
      this.dataList = [...list];
      this.total = result.data.data.total;
      this.listLoading = false;
    },
    resetOption() {
      this.fallPreventionTxt = '';
      this.queryForm = this.$options.data().queryForm;
      this.roadListItem = {};
      this.dictValueItem = {};
      this.getWellByPageDto();
    },
    submitSearch() {
      //先置空
      // this.queryForm.fallPrevention = ""
      // this.queryForm.fallPreventionForm = ""
      //
      // if (this.fallPreventionTxt === '' || this.fallPreventionTxt === '无') {
      //   this.queryForm.fallPrevention = ""
      // } else {
      //   //有
      //   this.queryForm.fallPrevention = "有"
      //   if (this.fallPreventionTxt.indexOf("防坠网") > -1) {
      //
      //     this.queryForm.fallPreventionForm = "防坠网"
      //
      //   }
      //   if (this.fallPreventionTxt.indexOf("防坠板") > -1) {
      //
      //     this.queryForm.fallPreventionForm = "防坠板"
      //   } else {
      //
      //   }
      // }

      this.queryForm.roadId = this.roadListItem.id;

      // console.log(this.queryForm)
      this.getWellByPageDto();
    },
    openUploadDialog() {
      this.filename = '';
      this.uploadDialogVisibleFlag = true;
    },
    async submitUploadFile() {
      if (this.filename.length === 0) {
        this.$message.error('请上传文件！');
        return;
      }

      const result = await uploadExcelWell(this.uploadFile.file);

      if (result.data.code === 200) {
        this.$message({ message: '上传成功', type: 'success' });

        this.resetOption();
        this.getWellByPageDto();
      } else {
        this.$message.error(result.data.message);
      }
    },
    //上传文件
    handlexlslFile(file) {
      this.uploadFile = file;
    },
    beforeFileUpload(file) {
      this.filename = file.name;
      // console.log('文件名:', file.name);
    },
    async downloadExcel() {
      // console.log(this.queryForm)

      let req = {
        current: 1,
        size: Number.MAX_SAFE_INTEGER,
      };

      try {
        const result = await exportExcelwell(req);
        // 从响应中获取 Blob 对象
        const blob = result.data;

        // 创建一个 URL 对象
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        let fileName = '管井报表_' + getCurrentFormattedDateTime() + '.xlsx';
        link.setAttribute('download', fileName); // 设置下载文件名
        document.body.appendChild(link);
        link.click();

        // 释放 URL 对象
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Download error:', error);
      }
    },
    regionNameChange() {
      this.queryForm.townCode = this.dictValueItem.dictValue;
      this.roadList = [];
      CommonApi.queryRoadList({
        townCode: this.dictValueItem.dictValue,
      }).then((res) => {
        if (res.data.code === 200) {
          this.roadList = res.data.data;
        } else {
          this.roadList = [];
        }
      });
    },
    blockOrBurst(obj) {
      // console.log(obj)
      blockOrBurst({ id: obj.id }).then((response) => {
        if (response.data.code === 200) {
          this.$message({ message: '修改成功', type: 'success' });

          this.getWellByPageDto();
        } else {
          this.$message.error(response.data.message);
        }
      });
    },
    afterCreated() {
      this.roadList = [];

      CommonApi.queryRoadList({
        townCode: this.$route.query.townCode,
      }).then((res) => {
        if (res.data.code === 200) {
          this.roadList = res.data.data;

          const roadId = this.$route.query.roadId;
          if (roadId != null) {
            // console.log(roadId)
            this.roadListItem = { id: parseInt(roadId) };

            this.$nextTick(() => {
              this.submitSearch();
            });
          }
        } else {
          this.roadList = [];
        }
      });
    },
    sourceFormat(row, column) {
      return row.source == 1 ? '雨水井' : '污水井';
    },
    downloadTemplateExcel() {
      window.open(process.env.VUE_APP_BASE_URL + '/common/template/3');
    },
  },
  created() {
    const townCode = this.$route.query.townCode;
    if (townCode != null) {
      this.getDictList().then(() => {
        if (townCode !== null) {
          this.dictValueItem = { dictValue: townCode };
          //手动请求
          this.afterCreated();
        } else {
          this.getLineByPageDto();
        }
      });
    } else {
      this.getDictList();
      this.getWellByPageDto();
    }
  },
};
</script>
